import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=66b3500e&scoped=true"
import script from "./operate.vue?vue&type=script&setup=true&lang=js"
export * from "./operate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./operate.vue?vue&type=style&index=0&id=66b3500e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b3500e",
  null
  
)

export default component.exports